@if (loading()) {
  <umss-skeleton variant="Object" />
} @else {
  <section
    class="subscription-widget"
    [class.subscription-widget--detailed]="variant() === 'Detailed'"
  >
    <div class="subscription-widget__header">
      @if (variant() === 'Compact') {
        <umss-icon
          name="phosphorCalendarBlank"
          size="20px"
          color="var(--color-icon-active)"
        />
      }

      <h3 class="subscription-widget__title">
        {{ title() }}
        @if (periodLabel(); as period) {
          <span class="subscription-widget__period">· {{ period }}</span>
        }
      </h3>

      @if (emptyMessage(); as message) {
        <p
          class="subscription-widget__legend subscription-widget__legend--empty"
        >
          {{ message }}
        </p>
      } @else {
        <p class="subscription-widget__legend">
          <span class="subscription-widget__legend-item">
            <span
              class="subscription-widget__dot subscription-widget__dot--worked"
              aria-hidden="true"
            ></span>
            <!-- Count and price share one flex item so they are separated by a
                 single space, not the item gap on top of collapsed whitespace. -->
            <span>
              Billable: {{ workedCount() }} shifts
              <strong class="subscription-widget__price">{{
                workedPrice() | currency: 'USD' : 'symbol' : '1.0-0'
              }}/mo</strong>
            </span>
          </span>

          <span class="subscription-widget__legend-item">
            <span
              class="subscription-widget__dot subscription-widget__dot--scheduled"
              aria-hidden="true"
            ></span>
            <span>
              Scheduled: {{ scheduledCount() }} shifts
              <strong class="subscription-widget__price">{{
                scheduledPrice() | currency: 'USD' : 'symbol' : '1.0-0'
              }}/mo</strong>
            </span>
          </span>
        </p>
      }

      @if (showViewAction()) {
        <umss-link-button
          class="subscription-widget__action"
          [label]="viewLabel()"
          leftIconName="phosphorEyeBold"
          iconSize="16px"
          iconColor="var(--color-icon-active)"
          size="small"
          (onClick)="viewClick.emit()"
        />
      }
    </div>

    <div class="subscription-widget__chart">
      <!-- The legend above carries the same figures as text, so the track and
           its positional marks are hidden from assistive tech rather than
           announced a second time. The tier captions below are not: they are
           pricing the legend does not state. -->
      <div class="subscription-widget__track" aria-hidden="true">
        @if (!emptyMessage()) {
          <div
            class="subscription-widget__fill subscription-widget__fill--scheduled"
            [style.width.%]="scheduledPercent()"
          ></div>
          <div
            class="subscription-widget__fill subscription-widget__fill--worked"
            [style.width.%]="workedPercent()"
          ></div>
        }

        @for (percent of boundaryPercents(); track $index) {
          <span
            class="subscription-widget__divider"
            [style.left.%]="percent"
          ></span>
        }
      </div>

      <div class="subscription-widget__scale" aria-hidden="true">
        @for (mark of scaleMarks(); track $index; let first = $first) {
          <span
            class="subscription-widget__mark"
            [class.subscription-widget__mark--first]="first"
            [style.left.%]="mark.percent"
          >
            {{ mark.value }}
          </span>
        }
      </div>

      @if (variant() === 'Detailed') {
        <div class="subscription-widget__tiers">
          @for (caption of tierCaptions(); track $index) {
            <span
              class="subscription-widget__tier-caption"
              [style.width.%]="caption.widthPercent"
            >
              {{ caption.price | currency: 'USD' : 'symbol' : '1.0-0' }}
            </span>
          }
        </div>
      }
    </div>
  </section>
}
